import zod from 'zod';
import { stringToBoolean, stringToListOfNumber, zodLimit, zodPage } from './helpers';
import { CitizenStatus } from '../services/central-api/citizen';

export const CitizenManagementSchema = zod.object({
    page: zodPage,
    limit: zodLimit(),
    textFilter: zod.string().optional(),
    status: zod.nativeEnum(CitizenStatus).optional()
});

export const CitizenLprEventsSchema = zod.object({
    citizenIds: stringToListOfNumber.optional(),
});

export const CitizenLprSearchSchema = zod.object({
    plate: zod.string().optional(),
    citizenIds: stringToListOfNumber.optional(),
    beginIn: zod.coerce.number().optional(),
    endIn: zod.coerce.number().optional(),
    irregularSituation: stringToBoolean.optional(),
});

export const CitizenBlockReasonsSchema = zod.object({
    page: zodPage,
    limit: zodLimit(),
    textFilter: zod.string().optional()
});

export const CitizenLprDetectionDetailsSchema = zod.object({
    id: zod.coerce.number(),
});
